import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';

class Changemode extends React.Component {

  state = {
    fullWidth: true,
    maxWidth: 'xs',
  }


  changeMode(modeId, mode) {
    let context = this;
    let id= this.props.id;
    let type = this.props.type;
    context.setState({ load: true, message: 'Changing Mode!!!' });
    $.ajax({
      type: 'POST',
      data: { id, type, modeId, mode },
      url: Server() + 'payment/changemode.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ open: false, load: false });
          context.props.updateData();
        }
        else {
          context.setState({ load: false, });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  submit(id, mode) {
    let context = this;
    if (this.props.from == 'payment') {
      this.changeMode(id, mode);
      return;
    }
    let originalData = this.props.data;
    let receiptId = this.props.id;
    context.setState({ load: true, message: 'Changing Mode!!!' });
    $.ajax({
      type: 'POST',
      data: { 'receiptId': receiptId, 'modeId': id, 'mode': mode },
      url: Server() + 'receipt/changemode.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ open: false, load: false });
          originalData.map((x) => {
            if (receiptId == x.id) { x.mode = mode; x.mode_id = id; }
          })
          context.props.updateData(originalData);
        }
        else {
          context.setState({ load: false, });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <b style={{color: '#415F9D'}} 
          onClick={ () => { 
                      if (!this.props.menuPermission.edit) {
                        alert('Access Defned!!!');
                        return;
                      }
                      this.setState({ open: true });
                    } 
                  }>{this.props.mode}</b>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.state.open}
          onClose={ () => { this.setState({ open: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Change Mode</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <List>
                { this.props.paymentmode.map((c) => {
                    return (
                      <ListItem id='pointer' onClick={this.submit.bind(this, c.id, c.mode)} style={{fontSize: 14}}><b>{c.mode}</b></ListItem>
                    )
                  })
                }
              </List>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) } }>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Changemode;